module.exports = __webpack_public_path__ + "assets/img/ebd9-es.svg";